import styled from 'styled-components';
import BrandImageViewer from 'components/BrandImageViewer';

/* eslint-disable import/prefer-default-export */
export const Wrap = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.palette.neutral01};
  display: flex;
`;

export const ViewerWrap = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.neutral01};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BrandImageViewerStyled = styled(BrandImageViewer)`
  width: 100%;
  height: 100%;
`;

export const Title = styled.div`
  ${({ theme }) => theme.textStyles.heading01global02};
`;

export const IconButton = styled.img`
  position: absolute;
  bottom: 12px;
  right: 12px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  z-index: 200;
`;



// WEBPACK FOOTER //
// /opt/build/repo/src/modules/main/components/Editor/Editor.styled.js